/** The arena card's one status line; danger-toned while pairing is paused. */
import React from 'react';
import {StyleSheet} from 'react-native';

import {Txt} from '../../ui';
import {NextPairingModel} from './NextPairing.model';

export default React.memo(function NextPairingView({
  label,
  paused,
}: NextPairingModel) {
  return (
    <Txt
      testID="v2-result-next-pairing"
      variant="label"
      tone={paused ? 'danger' : 'ink'}
      numeric
      style={styles.line}>
      {label}
    </Txt>
  );
});

const styles = StyleSheet.create({
  line: {
    textAlign: 'center',
  },
});
